import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isCollapse: false,
    tips: {
      isTips: false,
      msg: []
    },
    toTrainingButton: false,
    toTrainingDialog: false
  },
  mutations: {
    switchCollapse (state) {
      state.isCollapse = !state.isCollapse
    },

    closeCollapse(state){
      state.isCollapse = true
    },

    clearTips (state) {
      state.tips = {
        isTips: false,
        msg: []
      }
    },

    addTips (state,msg) {
      state.tips.isTips = true
      state.tips.msg = msg
    },

    toTrainingButton(state, data= false){
      state.toTrainingButton = data
    },

    openToTrainingDialog(state, data = false) {
      state.toTrainingDialog = data
    }
  }
})
